import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { FormFieldWrapper } from "../../core/shared/FormFieldWrapper";
import { Placeholder } from "./interfaces";
import RadixComponent from "./RadixComponent";
import React from "react";
import ReactSelectComponent from "./ReactSelectComponent";
export function Select({ size = "default", name, label, value, isMulti, options, waiting, disabled, feedback, searchable, lazyRender, placeholder = "Selecione um valor", massiveLabel, checkedFirst, hasPermission = true, orderOptionsBy = "ASC", lazyRenderAmount = 20, massiveSelectOption, permitClearSelected = true, onChange, onValidate, selectedValuesRender, ...props }) {
    const restProps = {
        name,
        label,
        value,
        feedback,
        onValidate,
        ...props,
    };
    const [feedbackType, setFeedbackType] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const orderedOptions = useMemo(() => {
        if (orderOptionsBy === "NORMAL" || !options.length)
            return options;
        const compare = (a, b) => {
            if (!a.label || !b.label || a.label === b.label)
                return 0;
            return a.label < b.label ? -1 : 1;
        };
        return [...options].sort(compare);
    }, [orderOptionsBy, options]);
    const filteredOptions = useMemo(() => {
        return orderedOptions.reduce((accum, atual) => {
            if (atual.value === value) {
                return [atual, ...accum.filter((option) => option.value !== atual.value)];
            }
            accum.push(atual);
            return accum;
        }, []);
    }, [orderedOptions, value]);
    const handleValueChange = (selected, method) => {
        const isPlaceholder = selected === Placeholder.Value;
        onChange({
            currentTarget: { value: isPlaceholder ? Placeholder.Empty : selected, name },
        }, method);
        if (!isMulti)
            setIsOpen(false);
    };
    const handleClearValue = () => {
        setIsOpen(false);
        handleValueChange(Placeholder.Value);
    };
    const commonProps = {
        size,
        name,
        value,
        isOpen,
        loading: props.loading,
        waiting,
        disabled,
        placeholder,
        feedbackType,
        hasPermission,
        setIsOpen,
        handleClearValue,
        handleValueChange,
    };
    const radixProps = {
        filteredOptions,
        permitClearSelected,
        ...commonProps
    };
    const reactSelectProps = {
        isMulti,
        searchable,
        lazyRender,
        massiveLabel,
        checkedFirst,
        orderedOptions,
        lazyRenderAmount,
        massiveSelectOption,
        selectedValuesRender,
        ...commonProps
    };
    const renderRadixComponent = !searchable && !isMulti;
    return (_jsx(FormFieldWrapper, { onChangeFeedback: (feedbackData) => setFeedbackType(feedbackData), size: size, ...restProps, feedback: feedback, hideFeedbackIcon: true, children: renderRadixComponent
            ? React.createElement(RadixComponent, radixProps)
            : React.createElement(ReactSelectComponent, reactSelectProps) }));
}
//# sourceMappingURL=index.js.map